// src/design-system/components/GlassCard.jsx
import React from 'react';

/**
 * GlassCard — Card com glassmorphism, backdrop-blur, borda sutil e glow hover.
 *
 * @param {string}  className  - Classes adicionais
 * @param {boolean} compact    - Padding reduzido
 * @param {boolean} elevated   - Elevação extra (mais contraste)
 * @param {boolean} noHover    - Desabilita hover glow
 * @param {string}  as         - Elemento HTML (default: 'article')
 * @param {node}    header     - Conteúdo do header
 * @param {node}    footer     - Conteúdo do footer
 * @param {node}    children   - Conteúdo do body
 */
export default function GlassCard({
  children,
  className = '',
  compact = false,
  elevated = false,
  noHover = false,
  as: Tag = 'article',
  header,
  footer,
  style,
  ...props
}) {
  const cls = [
    'ds-glass-card',
    compact && 'ds-glass-card--compact',
    elevated && 'ds-glass-card--elevated',
    noHover && 'ds-glass-card--no-hover',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={cls} style={style} {...props}>
      {header && <div className="ds-glass-card__header">{header}</div>}
      <div className="ds-glass-card__body">{children}</div>
      {footer && <div className="ds-glass-card__footer">{footer}</div>}
    </Tag>
  );
}
